module.exports = __webpack_public_path__ + "img/VideoPlay.png.ce9d1c53.svg";